import React, { useState, useEffect } from "react";
import config from "clientappsetting.json";
import "./HeaderStyles.scss";

import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { ContactDetails } from "components/ContactDetails";
import { ModalCentered } from "components/generic/ModalCentered";
import { BookingStageStepper } from "components/Steppers/BookingStageStepper";
import { BookingStepperMobile } from "components/Steppers/BookingStepperMobile";
import { getStage, StepId } from "logic/Navigation/Steps";
import BookingStepperVertical  from "components/Steppers/BookingStepperVertical";
import { MicrositeContactDetails } from "generated/types/types"; 
import { useSelector } from "react-redux";
import { RootState } from "redux/store/store";
import { LanguageSelector } from "components/LanguageSelector";
interface Props {
    currentStep: StepId;
    contactDetails: MicrositeContactDetails;
    setCurrentStep: (stepId: StepId) => void;
    isBookingCreationJourney: boolean;
    headerImageBlobGuid: string | null;
    favIconBlobGuid: string | null;
    customCompanyNames: string;
}

export const Header: React.FC<Props> = (props: Props) => {
    const { t, i18n } = useTranslation();
    const countryCode = useSelector((state: RootState) => state.country.countryCode);
    const isDk = (countryCode || "").toUpperCase() === "DK";
    const normaliseLang = (lng?: string) => {
    const l = (lng || "").toLowerCase();
    if (l === "dk" || l.startsWith("da")) return "dk";
        return "en";
    };

    const [langValue, setLangValue] = useState(() => {
    const stored = localStorage.getItem("i18nextLng") || undefined;
         return normaliseLang(i18n.resolvedLanguage || i18n.language || stored || "en");
    });

    const showLanguageSelector = isDk && props.currentStep === StepId.VehicleLookup;

    useEffect(() => {
        const sync = ((lng: string) => setLangValue(normaliseLang(lng))) as any;

        setLangValue(normaliseLang(i18n.resolvedLanguage || i18n.language));

        i18n.on("languageChanged", sync);
        return () => {
            i18n.off("languageChanged", sync);
        };
    }, [i18n]);

    const [isSlideOutSteppersOpen, setIsSlideOutStepperOpen] = useState(false);
    const [showContactDetailsModal, setShowContactDetailsModal] = useState(false);
    const contactDetails = props.contactDetails;
    const customCompanyName = props.customCompanyNames;

    const isBookingCreationJourney = props.isBookingCreationJourney;
        const onLanguageChange = async (e: React.ChangeEvent<HTMLSelectElement>) => {
        const newLang = e.target.value;
        setLangValue(newLang);
        await i18n.changeLanguage(newLang);
    };

    return (
        <>
            {isBookingCreationJourney ? (
                <div className="vertical-stepper" style={isSlideOutSteppersOpen ? { transform: "translateY(0)" } : { transform: "translateY(-100%)" }}>
                    {showLanguageSelector ? (
                        <div className="mobile-language-in-menu no-print">
                            <LanguageSelector
                                id="language-selector-mobile"
                                show
                                value={langValue}
                                onChange={onLanguageChange}
                            />
                        </div>
                        ) : null}
                    <BookingStepperVertical currentStep={props.currentStep} setCurrentStep={props.setCurrentStep} />
                </div>
            ) : null}
            <div className="container-fluid header-container small-when-printing">
                <div className="row coloured-spacer"></div>
                <div className="container">
                    <div className="row header-content">
                        <div className="col-2 vert-align-col logo">
                            {props.headerImageBlobGuid ? <img src={`${config.API_URL}/Blob/GetBlobFile/${props.headerImageBlobGuid}`} alt="brand logo" /> : ""}
                        </div>
                        {isBookingCreationJourney ? (
                            <div className="col-12 col-md order-last order-md-2 stepper-container">
                                <div className="desktop-stepper">
                                    <BookingStageStepper currentStep={props.currentStep} setCurrentStep={props.setCurrentStep} />
                                </div>
                                <div className="mobile-stepper">
                                    <BookingStepperMobile currentStep={props.currentStep} />
                                    {getStage(props.currentStep) !== null ? (
                                        <div
                                            className={
                                                "vertical-mobile-stepper--toggle" +
                                                (isSlideOutSteppersOpen ? " vertical-mobile-stepper--toggle-open" : " vertical-mobile-stepper--toggle-closed")
                                            }
                                            onClick={() => setIsSlideOutStepperOpen(!isSlideOutSteppersOpen)}
                                        ></div>
                                    ) : null}
                                </div>
                            </div>
                        ) : null}


                       <div className="col-12 col-md-auto order-md-3 vert-align-col help-link no-print">
                        <div className="help-language-inline">
                            <div className="link-action" onClick={() => setShowContactDetailsModal(true)}>
                              {t("header_need_help")}
                            </div>
                            <div className="language-selector-desktop">
                                <LanguageSelector
                                id="language-selector-desktop"
                                show={showLanguageSelector}
                                value={langValue}
                                onChange={onLanguageChange}
                                />
                            </div>
                        </div>
                       </div>


                    </div>
                </div>

                <div className="row spacer"></div>
            </div>
            <ModalCentered size="sm" show={showContactDetailsModal} onHide={() => setShowContactDetailsModal(false)}>
                <div className="custom-dialog">
                    <Modal.Header closeButton />
                    <p>{t("header_need_help_desc", { customCompanyName })}</p>
                    <hr />
                    <ContactDetails contactDetails={contactDetails} />
                </div>
            </ModalCentered>
        </>
    );
};
